import styled, { css } from 'styled-components';

type withDeviceVolume = {
  volumeHidden?: boolean;
};

const VideoPlayButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fff;
  border: none;
  padding: 12px;
  cursor: pointer;
`;

const VideoFullscreenButton = styled.button`
  width: 56px;
  height: 36px;
  background-color: rgb(26, 26, 26, 0.6);
  border-radius: 5px;
  padding: 5px 14px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const VideoControlsWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

const VideoControlsInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 40px 17px 30px;
`;

const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const VideoVolume = styled.input`
  width: 100px;
  margin-left: 24px;
`;

const VideoMute = styled.button`
  width: 17px;
  height: 17px;
  background: none;
  border: none;
  padding: 0;
  svg {
    width: 100%;
    height: 100%;
  }
  cursor: pointer;
`;

const thumbStyles = css`
  -webkit-appearance: none;
  appearance: none;
  border: none;
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: #ffffff;
  border: none;
  transform: translateY(-25%);
`;

const trackStyles = css`
  width: 100%;
  cursor: pointer;
  height: 4px;
  background: rgb(241, 241, 241, 0.5);
  border-radius: 1.3px;
  border: none;
`;

const VolumeControlsWrapper = styled.div<withDeviceVolume>`
  display: flex;
  margin: 0 12px;
  padding: 0;
  background-color: rgb(26, 26, 26, 0.6);
  border-radius: 5px;
  height: 36px;
  width: ${({ volumeHidden }) => (volumeHidden ? '40px' : '100px')};
  align-items: center;
  justify-content: center;
  cursor: pointer;

  /* Range slider overrides */
  input[type='range' i] {
    -webkit-appearance: none;
    appearance: none;
    width: 42px;
    margin: 0;
    margin-left: 7px;
    background: transparent; /* Otherwise white in Chrome */

    ::-webkit-slider-runnable-track {
      ${trackStyles}
    }
    ::-moz-range-track {
      ${trackStyles}
    }
    ::-ms-track {
      ${trackStyles}
    }
    ::-ms-fill-lower {
      ${trackStyles}
    }
    ::-ms-fill-upper {
      ${trackStyles}
    }

    ::-webkit-slider-thumb {
      ${thumbStyles}
    }
    ::-moz-range-thumb {
      ${thumbStyles}
    }
    ::-ms-thumb {
      ${thumbStyles}
    }
  }
`;

const StoryBookWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 70vh;
  background: #c8102e;
  video {
    min-width: 100%;
    min-height: 100%;
    object-fit: cover;
  }
`;

export {
  VideoPlayButton,
  VideoControlsWrapper,
  VideoVolume,
  VideoMute,
  VolumeControlsWrapper,
  StoryBookWrapper,
  VideoFullscreenButton,
  LeftWrapper,
  VideoControlsInnerWrapper,
};
